var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.412 4.58784C25.1755 4.35306 24.8789 4.18799 24.5548 4.11081C24.2307 4.03363 23.8914 4.04731 23.5745 4.15034L5.28704 10.2503C4.94788 10.3578 4.64818 10.5634 4.42578 10.8411C4.20338 11.1188 4.06827 11.4562 4.0375 11.8106C4.00674 12.1651 4.0817 12.5206 4.25293 12.8325C4.42417 13.1444 4.68397 13.3985 4.99954 13.5629L12.587 17.3129L16.337 24.9254C16.4878 25.2233 16.7184 25.4735 17.0032 25.6479C17.2879 25.8223 17.6157 25.914 17.9495 25.9129H18.0745C18.4322 25.8865 18.7735 25.7533 19.0544 25.5303C19.3353 25.3074 19.5427 25.0051 19.6495 24.6629L25.837 6.42534C25.9475 6.11026 25.9663 5.77027 25.891 5.44496C25.8158 5.11966 25.6497 4.82242 25.412 4.58784ZM6.06204 11.9753L22.0245 6.65034L13.162 15.5129L6.06204 11.9753ZM18.037 23.9379L14.487 16.8379L23.3495 7.97534L18.037 23.9379Z",
    fill: "#070B28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconSvg);
export default __webpack_public_path__ + "static/media/send-icon-svg.461d40da69047710013d807d25e92cb1.svg";
export { ForwardRef as ReactComponent };